import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { Config } from '../config';
import {  IToolBarClick, IObjectStatus } from '../models/common';
import { FrameworkService } from 'gadoe-framework';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  baseUrl: string = Config.ROOT_URL;
  pageUrl = '/api/Common';
  toolBarclickStatus: IToolBarClick = {
    toolbarItemId: 0, toolbarItemName: '',
    toolbarcontrolID: 0, isClicked: false
  };
  public toolBarclick: BehaviorSubject<IToolBarClick> = new BehaviorSubject<IToolBarClick>(this.toolBarclickStatus);
  constructor(private http: HttpClient, private frameworkService: FrameworkService) {
  }

  handleError(error: HttpErrorResponse) {
       if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return Observable.throw(errMessage);
      // Use the following instead if using lite-server
      // return Observable.throw(err.text() || 'backend server error');
    }
    return Observable.throw(error || 'Node.js server error');
  }
  GetObjectStatus(ObjectID: number, ObjectTypeID: number): Observable<IObjectStatus[]> {
    // this.frameworkService.log(Config.ROOT_URL + this.pageUrl + '/GetObjectStatus');
    return this.http.get<IObjectStatus[]>
      (Config.ROOT_URL + this.pageUrl + '/GetObjectStatus/' + ObjectID + '/' + ObjectTypeID,
      { headers: Config.httpHeaders })
      .pipe(
        map(results => {
          return results;
        }),
        catchError(this.handleError)
      );
  }
  CallProcessWorkFlow(objectID: number, ObjectTypeID: number, toolBarItemID: number,
     userID: number, roleID: number): Observable<IObjectStatus[]> {
       return this.http.get<IObjectStatus[]>
      (Config.ROOT_URL + this.pageUrl + '/CallProcessWorkFlow' + '/' +
      objectID + '/' + ObjectTypeID + '/' + toolBarItemID + '/' + roleID + '/'
     + userID, { headers: Config.httpHeaders })
      .pipe(
        map(results => {
          return results;
        }),
        catchError(this.handleError)
      );
  }

}
